define(["require", "exports", "jquery", "../../utils/tools"], function (require, exports, $, tools) {
    "use strict";
    var LogoutActions = /** @class */ (function () {
        function LogoutActions() {
        }
        LogoutActions.prototype.confirmLogout = function () {
            tools.confirmModal({
                title: "Logout",
                text: "Are you sure you want to logout?",
                buttonTitle: "Logout",
                type: "info",
                modalOptions: {}
            }, function (modal) {
                $(modal).modal("hide");
                window.location.href = "/Account/LogOff";
            });
        };
        return LogoutActions;
    }());
    return LogoutActions;
});
//# sourceMappingURL=logoutActions.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/reports/logoutActions.js
// module id = 91
// module chunks = 2